import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundVideo"] */ "/vercel/path0/src/components/background-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamMemberCard"] */ "/vercel/path0/src/components/team-member-card.tsx");
